import store from '@/store'
import { platformAgent } from '@/utils/utils'
let appEncrypt = function(config) {
  return new Promise(function(resolve, reject) {
    let result = SyHybridSdk.nativeHttpEncrypt({
      params: config.data,
      success: res => {
        getEncryptParams(res, resolve, reject)
      }
    })
    if (platformAgent() == 'android') {
      getEncryptParams(result, resolve, reject)
    }
  })
}

function getEncryptParams(result, resolve, reject) {
  if (typeof result == 'string') {
    result = JSON.parse(result)
  }
  store.commit('SET_QUERYS', result)
  resolve(result)
}

export { appEncrypt, appDecrypt }

let appDecrypt = function(response) {
  return new Promise((resolve, reject) => {
    let params =
      response.config.headers.token + '#' + JSON.stringify(response.data)
    let value = SyHybridSdk.nativeHttpDecrypt({
      params,
      success: res => {
        getDecryptResult(res, resolve, reject)
      },
      fail: err => {
        console.log(err)
      }
    })
    if (platformAgent() == 'android') {
      getDecryptResult(value, resolve, reject)
    }
  })
}
function getDecryptResult(result, resolve, reject) {
  result = SyHybridSdk.jiemi(result)
  if (typeof result == 'string') {
    result = JSON.parse(result)
  }
  resolve(result || {})
}
